const _500_dp = (externalBaseUrl: string) => ({
	structure: {
		type: 'Page',
		styleId: '_500_dp_style',
		id: '_500_dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bp',
				dataQuery: '#dataItem-ivs7j2bq',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs7j2bq1',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj519',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bs',
				dataQuery: '#dataItem-ivs7j2bs1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs7j2bs2',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj514',
			},
			{
				type: 'Component',
				styleId: 'style-ivs7k3ls',
				id: 'comp-ivs7j2bt',
				dataQuery: '#dataItem-ivs7j2bt1',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzl0lj58',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj59',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs7j2bw',
				dataQuery: '#dataItem-ivs7j2bw1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs7j2by',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj54',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bp',
				dataQuery: '#dataItem-ivs7j2bq',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzl0lj518',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj519',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bs',
				dataQuery: '#dataItem-ivs7j2bs1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzl0lj513',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj514',
			},
			{
				type: 'Component',
				styleId: 'style-ivs7k3ls',
				id: 'comp-ivs7j2bt',
				dataQuery: '#dataItem-ivs7j2bt1',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'mobile_propItem-lzzl0lj58',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj59',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs7j2bw',
				dataQuery: '#dataItem-ivs7j2bw1',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-ivs7j2by',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_500_dp',
				layoutQuery: '#layout-lzzl0lj54',
			},
		],
		dataQuery: '#_500_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			x: 0,
			y: 0,
			height: 0,
			width: 0,
		},
		componentType: 'mobile.core.components.Page',
		layoutQuery: '#layout-lzzl0lj5',
	},
	data: {
		document_data: {
			'dataItem-ivs7j2bq': {
				type: 'StyledText',
				id: 'dataItem-ivs7j2bq',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#F6A23B"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">Time&nbsp;Out</span></span></span></h4>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs7j2bs1': {
				type: 'StyledText',
				id: 'dataItem-ivs7j2bs1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">This page isn&rsquo;t available right now. But we&rsquo;re working on a fix, ASAP. Try again soon. </span></span></span></p>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs7j2bt1': {
				type: 'LinkableButton',
				id: 'dataItem-ivs7j2bt1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Back ',
				link: '#dataItem-iwirzq0v',
			},
			'dataItem-ivs7j2bw1': {
				type: 'Image',
				id: 'dataItem-ivs7j2bw1',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '500.png',
				uri: '035244_16f5e2c6277141a6a6e85cdde7b8e53a~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
				crop: {
					x: 27,
					y: 21,
					width: 346,
					height: 239,
				},
			},
			'dataItem-iwirzq0v': {
				type: 'ExternalLink',
				id: 'dataItem-iwirzq0v',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: externalBaseUrl,
				target: '_self',
			},
			_500_dp: {
				type: 'Page',
				id: '_500_dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: '500',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: '500',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs7k3ls': {
				type: 'TopLevelStyle',
				id: 'style-ivs7k3ls',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#F6A23B',
						'boxShadowToggleOn-shd': 'false',
						brd: '#F6A23B',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#F6A23B',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-ivs7j2bq1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-ivs7j2bs2': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
			},
			'propItem-ivs7j2bq1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-ivs7j2bs2': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-ivs7j2bu': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-ivs7j2by': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
			'propItem-lzzl0lj58': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				id: 'propItem-lzzl0lj58',
			},
			'mobile_propItem-lzzl0lj58': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				fontScale: 0.863837598531476,
				id: 'mobile_propItem-lzzl0lj58',
			},
			'propItem-lzzl0lj513': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				fontScale: 0.6948499742213815,
				id: 'propItem-lzzl0lj513',
			},
			'propItem-lzzl0lj518': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
				fontScale: 0.8084127123905273,
				id: 'propItem-lzzl0lj518',
			},
		},
		variants_data: {},
		layout_data: {
			'layout-lzzl0lj5': {
				id: 'layout-lzzl0lj5',
				type: 'RefArray',
				values: ['#layout-lzzl0lj51', '#layout-lzzl0lj53'],
			},
			'layout-lzzl0lj51': {
				id: 'layout-lzzl0lj51',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj52': {
				id: 'layout-lzzl0lj52',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj53': {
				id: 'layout-lzzl0lj53',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzl0lj52',
				from: '#_500_dp',
			},
			'layout-lzzl0lj54': {
				id: 'layout-lzzl0lj54',
				type: 'RefArray',
				values: ['#layout-lzzl0lj55', '#layout-lzzl0lj57'],
			},
			'layout-lzzl0lj55': {
				id: 'layout-lzzl0lj55',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 339,
					},
					height: {
						type: 'px',
						value: 235,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 174,
						y: 100,
						width: 339,
						height: 235,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj56': {
				id: 'layout-lzzl0lj56',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 272,
					},
					height: {
						type: 'px',
						value: 196,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 24,
						y: -23,
						width: 272,
						height: 196,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj57': {
				id: 'layout-lzzl0lj57',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzl0lj56',
				from: '#comp-ivs7j2bw',
			},
			'layout-lzzl0lj59': {
				id: 'layout-lzzl0lj59',
				type: 'RefArray',
				values: ['#layout-lzzl0lj510', '#layout-lzzl0lj512'],
			},
			'layout-lzzl0lj510': {
				id: 'layout-lzzl0lj510',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 198,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 599,
						width: 198,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj511': {
				id: 'layout-lzzl0lj511',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 204,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 53,
						y: 372,
						width: 204,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj512': {
				id: 'layout-lzzl0lj512',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzl0lj511',
				from: '#comp-ivs7j2bt',
			},
			'layout-lzzl0lj514': {
				id: 'layout-lzzl0lj514',
				type: 'RefArray',
				values: ['#layout-lzzl0lj515', '#layout-lzzl0lj517'],
			},
			'layout-lzzl0lj515': {
				id: 'layout-lzzl0lj515',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 475,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 207,
						y: 482,
						width: 475,
						height: 76,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj516': {
				id: 'layout-lzzl0lj516',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 277,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 21,
						y: 265,
						width: 277,
						height: 78,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj517': {
				id: 'layout-lzzl0lj517',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzl0lj516',
				from: '#comp-ivs7j2bs',
			},
			'layout-lzzl0lj519': {
				id: 'layout-lzzl0lj519',
				type: 'RefArray',
				values: ['#layout-lzzl0lj520', '#layout-lzzl0lj522'],
			},
			'layout-lzzl0lj520': {
				id: 'layout-lzzl0lj520',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 701,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 379,
						width: 701,
						height: 81,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj521': {
				id: 'layout-lzzl0lj521',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 320,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 0,
						y: 208,
						width: 320,
						height: 39,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzl0lj522': {
				id: 'layout-lzzl0lj522',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzl0lj521',
				from: '#comp-ivs7j2bp',
			},
		},
		transformations_data: {},
	},
	title: '500',
	pageUriSEO: '500',
})

export default _500_dp
